import store from "../store"
import { socialConnect, getCurrentOrg } from "actions/organization"
import { facebook as connectFacebook } from "actions/facebook"
import { toggleFacebookConnected } from "actions/facebookConnectedDialog"
import { getLinkedInAuthCode } from "actions/linkedIn"
import { getHootsuiteAuthCode } from "actions/hootsuite"
import { getYoutubeAuthCode } from "actions/youtube"
import { openSnackBar } from "actions/snack-bar"

export const handleConnect = (network, id) => {
  switch (network) {
    case "Twitter":
    case "TweetDeck":
      store
        .dispatch(socialConnect(id))
        .then(res => {
          store.dispatch(openSnackBar({ message: "Twitter Added" }))
        })
        .catch(error =>
          store.dispatch(openSnackBar({ message: "Failed to add network." }))
        )
      break
    case "Facebook":
      store.dispatch(toggleFacebookConnected())
      store
        .dispatch(connectFacebook())
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
      break
    case "LinkedIn":
      store
        .dispatch(getLinkedInAuthCode())
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          store.dispatch(openSnackBar({ message: "Failed to add network." }))
        })

      break
    case "Hootsuite":
      store
        .dispatch(getHootsuiteAuthCode())
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
      break
    case "Youtube":
    case "YouTube":
      store
        .dispatch(getYoutubeAuthCode())
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
      break
    default:
      return
  }
  store.dispatch(getCurrentOrg())
}



// WEBPACK FOOTER //
// ./src/utils/handleSocialConnect.js